import { render, staticRenderFns } from "./PrivacyView.vue?vue&type=template&id=be6b0dbc&scoped=true&"
import script from "./PrivacyView.vue?vue&type=script&lang=js&"
export * from "./PrivacyView.vue?vue&type=script&lang=js&"
import style0 from "./PrivacyView.vue?vue&type=style&index=0&id=be6b0dbc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be6b0dbc",
  null
  
)

export default component.exports